<template>
    <v-container class="max-container">
        <!--PROLIFE-SCREEN-->
            <v-row class="prolife__row">
                <!--PROLIFE-IMG-->
                    <v-col class="prolife__row__colimg" :cols=" activateDynamism ? '12' : '4' ">
                        <v-row class="prolifeimg__row">
                            <v-col v-if="!activateDynamism" class="prolifeimg__row__coltitle" cols="6">
                                <v-skeleton-loader class="prolifeimg__row__coltitle__title" type="image"/>
                            </v-col>
                            <v-col class="prolifeimg__row__colphotograph" :cols="activateDynamism ? '3' :'5' ">
                                <v-skeleton-loader class="prolifeimg__row__colphotograph__photograph" type="image"/>
                            </v-col>
                            <v-col v-if="!activateDynamism" class="prolifeimg__row__colbtn no-pd-l" cols="5">
                                <v-skeleton-loader class="prolifeimg__row__colbtn__btn" type="image"/>
                            </v-col>
                            <v-col v-if="!activateDynamism" class="prolifeimg__row__coldelete no-pd-l" cols="5">
                                <v-skeleton-loader type="text"/>
                            </v-col>
                        </v-row>
                    </v-col>
                <!--END-PROLIFE-IMG-->
                <!--PROLIFE-INFO-->
                    <v-col class="prolife__row__colinfo" :cols=" activateDynamism ? '12' : '8' ">
                        <v-row class="prolifeinfo__rowname">
                            <v-col class="prolifeinfo__rowname__coltitlename no-pd-b" cols="3">
                                <v-skeleton-loader class="prolifeinfo__rowname__coltitlename__titlename" type="text"/>
                            </v-col>
                            <v-col class="prolifeinfo__rowname__colsubitlename no-pd-t" :cols="activateDynamism ? '12' : '10'">
                                <v-skeleton-loader class="prolifeinfo__input" type="image"/>
                            </v-col>
                        </v-row>
                        <v-row v-for="n in 2" :key="n" class="prolifeinfo__rowmoreinfo" style="" >
                            <v-col :cols=" activateDynamism ? colDynamic :  '5'" class="prolifeinfo__rowmoreinfo__col1 no-pd-l no-pd-r" >
                                <v-row class="prolifeinfo__rowmoreinfo__col1__row1">
                                    <v-col class="no-pd-b" cols="4">
                                        <v-skeleton-loader type="text"/>
                                    </v-col>
                                    <v-col class="no-pd-t" cols="12">
                                        <v-skeleton-loader class="prolifeinfo__input" type="image"/>
                                    </v-col>
                                </v-row>                                
                            </v-col>
                            <v-col :cols=" activateDynamism ? colDynamic :'5'" class="prolifeinfo__rowmoreinfo__col1 no-pd-l">
                                <v-row class="prolifeinfo__rowmoreinfo__col1__row1 ">
                                    <v-col class="no-pd-b" cols="4">
                                        <v-skeleton-loader type="text"/>
                                    </v-col>
                                    <v-col class="no-pd-r no-pd-t" cols="12">
                                        <v-skeleton-loader class="prolifeinfo__input" type="image"/>
                                    </v-col>
                                </v-row>                                
                            </v-col>
                        </v-row>
                        <v-row class="prolifeinfo__rowacceptinfo">
                            <v-col cols="7">
                                <v-skeleton-loader type="text"/>
                            </v-col>
                            <v-col cols="6">
                                <v-skeleton-loader type="text"/>
                            </v-col>
                        </v-row>
                    </v-col>
                <!--END-PROLIFE-INFO-->
            </v-row>
        <!--END-PROLIFE-SCREEN-->
    </v-container>
</template>

<script>
export default {
    name: 'prolifeLoader',
    data: () => ({
        activateDynamism: false,
        colDynamic:       6
    }),
    created() {
        this.compareWidth();
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
         compareWidth() {
            ( window.innerWidth < 769 ) ? this.activateDynamism = true : this.activateDynamism = false;

            ( window.innerWidth < 601 ) ? this.colDynamic = 12 : this.colDynamic = 6;
        },
    }
}
</script>

<style scoped>
/*RESPONSIVIT*/
    @media(max-width: 769px) {
        .prolife__row {
            display: flex;
            flex: auto !important;
            flex-direction: column !important;
        }
        .prolifeimg__row__colphotograph__photograph {
            height: 119px !important;
            border-radius: 64px !important;
            width: 115px !important;
        }
    }
    @media(max-width: 600px) {
        .prolifeinfo__rowmoreinfo {
            flex-direction: column !important;
        }
    }
/*END-RESPONSIVIT*/
/*PROLIFE-SCREEN*/
    .prolife__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }

/*END-PROLIFE-SCREEN*/
/*PROLIFE-IMG*/
    .prolifeimg__row {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        align-items: center;
    }
    .prolifeimg__row__coltitle__title {
        height: 20px;
        border-radius: 10px;
        margin-bottom: 18px;
    }
    .prolifeimg__row__colphotograph {
        padding-left: 8px;
        min-width: 134px;
    }
    .prolifeimg__row__colphotograph__photograph {
        height: 130px;
        width: 132px;
        border-radius: 64px;        
    }
    .prolifeimg__row__colbtn__btn {
        height: 36px;
        border-radius: 16px;
        margin-top: 8px;
        margin-bottom: 8px;
    }
/*END-PROLIFE-IMG*/
/*PROLIFE-INFO*/    
    .prolifeinfo__input {
        height: 26px;
        border-radius: 10px;
    }
    .prolifeinfo__rowname {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .prolifeinfo__rowmoreinfo {
        display:flex;
        flex-direction: row;
        margin-top: 16px; 
        margin-bottom: 22px;
    }
    .prolifeinfo__rowmoreinfo__col1__row1 {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .prolifeinfo__rowacceptinfo {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
/*END-PROLIFE-INFO*/
</style>